<template>
    <section>
        <o-field>
            <o-checkbox indeterminate label="Default" />
        </o-field>

        <o-field>
            <o-checkbox variant="primary" indeterminate label="Primary" />
        </o-field>

        <o-field>
            <o-checkbox variant="secondary" indeterminate label="Secondary" />
        </o-field>

        <o-field>
            <o-checkbox variant="success" indeterminate label="Success" />
        </o-field>

        <o-field>
            <o-checkbox variant="info" indeterminate label="Info" />
        </o-field>

        <o-field>
            <o-checkbox variant="warning" indeterminate label="Warning" />
        </o-field>

        <o-field>
            <o-checkbox variant="danger" indeterminate label="Danger" />
        </o-field>
    </section>
</template>
